import { SortOptionType } from '@/types/srp'
import { capitalizeFirstLetter } from '@/utils'
import { ProcessedData } from '@/utils/srp/types'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { useEffect, useState } from 'react'
import Pointer from '../../../itinerary/Desktop/icons/pointer.svg'

type SortOptionsType = {
    activeSort: SortOptionType[]
    setActiveSort: (activeSort: SortOptionType[] | ((prevState: SortOptionType[]) => SortOptionType[])) => void
    isLoading: boolean
    processedData: Partial<ProcessedData>
}

const SortOptionsFFRT: React.FC<SortOptionsType> = ({
    activeSort,
    setActiveSort,
    isLoading,
    processedData
}) => {
  const [selectedSort, setSelectedSort] = useState(activeSort);
  // As the user will scroll down the value will increase or not boolean, that means an up arrow
  const headingsObjArary = [{width: '80px', key: "departure"}, {width: '220px', key: "duration"}, {key: "price"}];

  useEffect(() => {
    if(activeSort) {
      setSelectedSort(activeSort);
    }
  }, [activeSort]);

  if (isLoading) {
    return <></>
  }

  const handleFilterClick = (headingClicked: string, index: number) => {
    const newIsLowToHigh = headingClicked === selectedSort[index].sortingBasis ? selectedSort[index].sortType === 'asc' ? 'desc' : 'asc' : 'asc';

    const upOrDown = newIsLowToHigh === 'asc' ? "up" : "down";
    switch (index) {
      case 0: {
        const returnSort = activeSort[1];
        setActiveSort([
          { 
            title: "",
            sortType: newIsLowToHigh,
            sortKey: `${headingClicked}_${upOrDown}`,
            sortingBasis: headingClicked
          },
          {...returnSort}
        ]);
        return;
      }
      case 1: {
        const toSort = activeSort[0];
        setActiveSort([
          {...toSort},
          { 
            title: "",
            sortType: newIsLowToHigh,
            sortKey: `${headingClicked}_${upOrDown}`,
            sortingBasis: headingClicked
          }
        ]);
        return;
      }
    };
  };

  return (
    <Container className='flex'>
      <Container className='flex br-4 py-2 px-3' style={{backgroundColor: '#f7f7f7', marginRight: '18px'}} width='435px'>
        <Container width='85px'>
          <Typography variant='P3' color='subheading'>Airline</Typography>
        </Container>
        {headingsObjArary.map((headingObj) => {
          return (
            <Container className='flex' width={headingObj.width} onClick={() => handleFilterClick(headingObj.key, 0)}>
              <Typography variant='P3' className='c-pointer mr-1 t-sentence' color={selectedSort[0].sortingBasis === headingObj.key ? 'link2' : 'subheading'}>{capitalizeFirstLetter(headingObj.key)}</Typography>
              {selectedSort[0].sortingBasis === headingObj.key && <Pointer width="5px" height="12px" style={{transform: selectedSort[0].sortType === 'asc' ? 'rotate(-180deg)' : '', color: '#3366CC', paddingTop: selectedSort[0].sortType === 'asc' ? '' : '4px' }}/>}
            </Container>
          );
        })}
      </Container>
      <Container className='flex br-4 py-2 px-3' style={{backgroundColor: '#f7f7f7'}} width='433px'>
        <Container width='85px'>
          <Typography variant='P3' color='subheading'>Airline</Typography>
        </Container>
        {headingsObjArary.map((headingObj) => {
          return (
            <Container className='flex' width={headingObj.width} onClick={() => handleFilterClick(headingObj.key, 1)}>
              <Typography variant='P3' className='c-pointer mr-1 t-sentence' color={selectedSort[1].sortingBasis === headingObj.key ? 'link2' : 'subheading'}>{capitalizeFirstLetter(headingObj.key)}</Typography>
              {selectedSort[1].sortingBasis === headingObj.key && <Pointer width="5px" height="12px" style={{transform: selectedSort[1].sortType === 'asc' ? 'rotate(-180deg)' : '', color: '#3366CC', paddingTop: selectedSort[1].sortType === 'asc' ? '' : '4px' }}/>}
            </Container>
          );
        })}
      </Container>
    </Container>
  );
}

export default SortOptionsFFRT
